import * as actionTypes from './actionTypes'
import { dashboardService } from '../../service'
import { errorHelper } from '../../common/helpers'
import { constants } from '../../common/constants'


export function getAverageTicket({ startDate, endDate, store, reset = false } = {}) {
    return async (dispatch) => {
        try {
            if (reset == true) dispatch({ type: actionTypes.RESET_AVERAGE_TICKET })

            dispatch({ type: actionTypes.FETCH_AVERAGE_TICKET })

            const response = await dashboardService.getAverageTicket(startDate, endDate, store)
            const data = response.data

            if (data.message) {
                dispatch({
                    type: actionTypes.FETCH_AVERAGE_TICKET_FAILURE,
                    payload: { error: data.message }
                })

                return
            }
            dispatch({
                type: actionTypes.FETCH_AVERAGE_TICKET_SUCCESS,
                payload: {
                    averageTicket: data.data,
                    total: data.quantity,
                }
            })
        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.FETCH_AVERAGE_TICKET_FAILURE)
        }
    }
}

export function getNewClients({ startDate, endDate, store, reset = false } = {}) {
    return async (dispatch) => {
        try {
            if (reset == true) dispatch({ type: actionTypes.RESET_NEW_CLIENTS })

            dispatch({ type: actionTypes.FETCH_NEW_CLIENTS })

            const response = await dashboardService.getNewClients(startDate, endDate, store)
            const data = response.data

            if (data.message) {
                dispatch({
                    type: actionTypes.FETCH_NEW_CLIENTS_FAILURE,
                    payload: { error: data.message }
                })

                return
            }
            dispatch({
                type: actionTypes.FETCH_NEW_CLIENTS_SUCCESS,
                payload: {
                    newClients: data.data,
                    total: data.quantity,
                }
            })
        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.FETCH_NEW_CLIENTS_FAILURE)
        }
    }
}

export function getTopCustomers({ startDate, endDate, store, storeCompare, reset = false } = {}) {
    return async (dispatch) => {
        try {
            if (reset == true) dispatch({ type: actionTypes.RESET_TOP_CUSTOMERS })

            dispatch({ type: actionTypes.FETCH_TOP_CUSTOMERS })

            const response = await dashboardService.getTopCustomers(startDate, endDate, store)
            const data = response.data
            const responseCompare = await dashboardService.getTopCustomers(startDate, endDate, storeCompare)
            const dataCompare = responseCompare.data

            if (data.message) {
                dispatch({
                    type: actionTypes.FETCH_TOP_CUSTOMERS_FAILURE,
                    payload: { error: data.message }
                })

                return
            }

            dispatch({
                type: actionTypes.FETCH_TOP_CUSTOMERS_SUCCESS,
                payload: {
                    topCustomers: data.data,
                    total: data.quantity,
                    pageSize: data.pageSize,
                    topCustomersCompare: dataCompare.data,
                    totalCompare: dataCompare.quantity,
                    pageSizeCompare: data.pageSize,
                }
            })
        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.FETCH_TOP_CUSTOMERS_FAILURE)
        }
    }
}

export function getSellsByDay({ month, year, store, reset = false } = {}) {
    return async (dispatch) => {
        try {
            if (reset == true) dispatch({ type: actionTypes.RESET_SELLS_BY_DAY })

            dispatch({ type: actionTypes.FETCH_SELLS_BY_DAY })

            const response = await dashboardService.getSellsByDay(month, year, store)
            const data = response.data

            if (data.message) {
                dispatch({
                    type: actionTypes.FETCH_SELLS_BY_DAY_FAILURE,
                    payload: { error: data.message }
                })

                return
            }

            dispatch({
                type: actionTypes.FETCH_SELLS_BY_DAY_SUCCESS,
                payload: {
                    sellsByDay: data.data,
                    total: data.quantity
                }
            })
        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.FETCH_SELLS_BY_DAY_FAILURE)
        }
    }
}
export function getSellsByHour({ requestDate, store, state, reset = false } = {}) {
    return async (dispatch) => {
        try {
            if (reset == true) dispatch({ type: actionTypes.RESET_SELLS_BY_HOUR })

            dispatch({ type: actionTypes.FETCH_SELLS_BY_HOUR })

            const response = await dashboardService.getSellsByHour(requestDate, store, state)
            const data = response.data

            if (data.message) {
                dispatch({
                    type: actionTypes.FETCH_SELLS_BY_HOUR_FAILURE,
                    payload: { error: data.message }
                })

                return
            }

            dispatch({
                type: actionTypes.FETCH_SELLS_BY_HOUR_SUCCESS,
                payload: {
                    sellsByHour: data.data,
                    total: data.quantity
                }
            })
        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.FETCH_SELLS_BY_HOUR_FAILURE)
        }
    }
}
export function getSellsByMonth({ year, store, reset = false } = {}) {
    return async (dispatch) => {
        try {
            if (reset == true) dispatch({ type: actionTypes.RESET_SELLS_BY_MONTH })

            dispatch({ type: actionTypes.FETCH_SELLS_BY_MONTH })

            const response = await dashboardService.getSellsByMonth(year, store)
            const data = response.data

            if (data.message) {
                dispatch({
                    type: actionTypes.FETCH_SELLS_BY_MONTH_FAILURE,
                    payload: { error: data.message }
                })

                return
            }

            dispatch({
                type: actionTypes.FETCH_SELLS_BY_MONTH_SUCCESS,
                payload: {
                    sellsByMonth: data.data,
                    total: data.quantity
                }
            })
        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.FETCH_SELLS_BY_MONTH_FAILURE)
        }
    }
}
export function getSellsTopEmployees({ startDate, endDate, store, reset = false } = {}) {
    return async (dispatch) => {
        try {
            if (reset == true) dispatch({ type: actionTypes.RESET_SELLS_TOP_EMPLOYEES })

            dispatch({ type: actionTypes.FETCH_SELLS_TOP_EMPLOYEES })

            const response = await dashboardService.getSellsTopEmployees(startDate, endDate, store)
            const data = response.data

            if (data.message) {
                dispatch({
                    type: actionTypes.FETCH_SELLS_TOP_EMPLOYEES,
                    payload: { error: data.message }
                })

                return
            }

            dispatch({
                type: actionTypes.FETCH_SELLS_TOP_EMPLOYEES_SUCCESS,
                payload: {
                    sellsTopEmployees: data.data,
                    total: data.quantity
                }
            })
        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.FETCH_SELLS_TOP_EMPLOYEES_FAILURE)
        }
    }
}
export function getSellsTopCategories({ startDate, endDate, store, reset = false } = {}) {
    return async (dispatch) => {
        try {
            if (reset == true) dispatch({ type: actionTypes.RESET_SELLS_TOP_CATEGORIES })

            dispatch({ type: actionTypes.FETCH_SELLS_TOP_CATEGORIES })

            const response = await dashboardService.getSellsTopCategories(startDate, endDate, store)
            const data = response.data

            if (data.message) {
                dispatch({
                    type: actionTypes.FETCH_SELLS_TOP_CATEGORIES,
                    payload: { error: data.message }
                })

                return
            }

            dispatch({
                type: actionTypes.FETCH_SELLS_TOP_CATEGORIES_SUCCESS,
                payload: {
                    sellsTopCategories: data.data,
                    total: data.quantity
                }
            })
        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.FETCH_SELLS_TOP_CATEGORIES_FAILURE)
        }
    }
}

export function getStoreVisitor({ startDate, endDate, store, reset = false } = {}) {
    return async (dispatch) => {
        try {
            if (reset == true) dispatch({ type: actionTypes.RESET_STORE_VISITORS })

            dispatch({ type: actionTypes.FETCH_STORE_VISITORS })

            const response = await dashboardService.getStoreVisitor(startDate, endDate, store)
            const data = response.data

            if (data.message) {
                dispatch({
                    type: actionTypes.FETCH_STORE_VISITORS_FAILURE,
                    payload: { error: data.message }
                })

                return
            }

            dispatch({
                type: actionTypes.FETCH_STORE_VISITORS_SUCCESS,
                payload: {
                    storeVisitors: data.data,
                    total: data.quantity,
                }
            })
        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.FETCH_STORE_VISITORS_FAILURE)
        }
    }
}

export function getFranchiseReport({ month, year, page = constants.GET_ALL_ITEMS, size = 30, reset = false } = {}) {
    return async (dispatch) => {
        try {
            if (reset == true) dispatch({ type: actionTypes.RESET_FRANCHISE_REPORT })
            dispatch({ type: actionTypes.FETCH_FRANCHISE_REPORT })

            const response = await dashboardService.getFranchiseDetail(month, year, page, size)
            const data = response.data

            if (data.message) {
                dispatch({ type: actionTypes.FETCH_FRANCHISE_REPORT_FAILURE })
                return
            }
            dispatch({
                type: actionTypes.FETCH_FRANCHISE_REPORT_SUCCESS,
                payload: {
                    data: data.data,
                    total: data.quantity,
                    pageSize: data.pageSize,
                }
            })

        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.FETCH_FRANCHISE_REPORT_FAILURE)
        }
    }

}


// WEBPACK FOOTER //
// ./src/store/dashboard/actions.js